import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const achievementsSection = {
  init() {
    const sections = document.querySelectorAll('[data-recent-achievements-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.initSwiper(section);
    })
  },
  initSwiper(section) {
    let el = section.querySelector('.swiper');
    if (!el) return;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 3.45,
      spaceBetween: 30,
      loop: false,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        512: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 3.46,
          spaceBetween: 30,
        },
      },
    });
  },
}

window.addEventListener('load', () => {
  achievementsSection.init();
});
